import { cva } from "@mobsuccess-devops/styled-system/css";
import { styled } from "@mobsuccess-devops/styled-system/jsx";

const titleStyle = cva({
  base: {
    textStyle: "title",
    color: "interface",
  },
});

export const Title = styled("h1", titleStyle);
